import {XauditModel} from '../xaudit.model';
import {EnumValidValueItemModel} from '../enum/enum-valid-value-item.model';

export class DocumentTagDataModel extends XauditModel {
  DocumentID: string;
  DocumentTagID: string;
  enumDocumentTag: EnumValidValueItemModel;
  enumDocumentTagID: string;
}
